// extracted by mini-css-extract-plugin
export default {"listContainer":"PermissionsCheckList_listContainer__8ikJr"};